import { cn } from "src/common/utils";

// Official Cursor logo, served from cursor.com/marketing-static/favicon.svg.
// The SVG already includes its own dark background so we don't wrap it.
const CursorIcon = ({ className }: { className?: string }) => (
  <img src="/images/cursor-logo.svg" alt="Cursor" className={cn(className, "object-contain")} />
);

export default CursorIcon;
